"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var typography_1 = require("../../../../typography");
var styles_1 = require("./styles");
var SummaryListItem = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, price = _a.price, _b = _a.isBold, isBold = _b === void 0 ? false : _b;
    return (react_1.default.createElement(styles_1.Wrapper, { "data-component-name": "SummaryListItem", "$isBold": isBold },
        react_1.default.createElement("div", null,
            react_1.default.createElement(typography_1.Body, { level: "3", inline: true }, title),
            subtitle && (react_1.default.createElement(typography_1.Body, { level: "4", color: "GREY_70" }, subtitle))),
        react_1.default.createElement(typography_1.Mono, { level: "2" }, price)));
};
exports.default = SummaryListItem;
